export default __webpack_public_path__ + "static/media/elta-gold.01b1a482.png";